import {
  AuditTrailAction,
  AuditTrailEntityType,
  Gender,
  NotificationType,
  PromotionStatus,
  PromotionType,
  Role,
  StudentStatus,
} from "./Enums";

export const localBaseURL = "http://localhost:5130/api/";
export const baseURL = "https://breign.azurewebsites.net/api";
export const loginEndpoint = "authentication/login";
export const registerEndpoint = "authentication/register";
export const refreshTokenEndpoint = "authentication/refreshtoken";
export const forgotPasswordEndpoint = "authentication/forgotpassword";
export const healthDbEndpoint = "health/db";

export const GOOGLE_BUG_FORM_URL =
  "https://docs.google.com/forms/d/e/1FAIpQLSfkGFox2ufAG8JhAAaIGnYijeXY13VJssG6eJpxZTOL4Zj_-w/viewform?usp=header";
export const GOOGLE_FEATURE_FORM_URL =
  "https://docs.google.com/forms/d/e/1FAIpQLSfC8pjkpWoKVjudI1zModovUaDdbu4uXJDm1-H_7AXBn1mX_w/viewform?usp=header";
export const CALENDLY_URL = "https://calendly.com/jukevillehq/30min";

// const YOUTUBE_DEMO_EMBED_URL = "https://www.youtube.com/embed/VIDEO_ID?rel=0";

export const dashBoardRoute = "/";
export const studentsRoute = "/students";
export const resultsRoute = "/results";
export const settingsRoute = "/settings";
export const loginRoute = "/auth/login";
export const registerRoute = "/auth/register";
export const mobileQuery = ["(max-width: 600px)"];

export const titles: string[] = [
  "Mr.",
  "Mrs.",
  "Chief",
  "Dr.",
  "Barr.",
  "Alh.",
  "Engr.",
  "Madam",
  "Sir.",
  "Elder",
  "Pst.",
  "Rev.",
];

export const genders: { name: string; value: number }[] = [
  { name: "Male", value: Gender.Male },
  { name: "Female", value: Gender.Female },
  { name: "Others", value: Gender.Others },
];

export const genderMap: Record<number, string> = {
  [Gender.Male]: "Male",
  [Gender.Female]: "Female",
  [Gender.Others]: "Others",
};

export const roleMap: Record<number, string> = {
  [Role.Viewer]: "Viewer",
  [Role.Teacher]: "Teacher",
  [Role.Editor]: "Editor",
  [Role.Admin]: "Admin",
};

export const roles: { name: string; value: number }[] = [
  { name: "Viewer", value: Role.Viewer },
  { name: "Teacher", value: Role.Teacher },
  { name: "Editor", value: Role.Editor },
  { name: "Admin", value: Role.Admin },
];

export const adminPolicy: number[] = [3];
export const editorPolicy: number[] = [1, 2, 3];
export const viewerPolicy: number[] = [0];

export const studentStatusOptions: { label: string; value: string }[] = [
  { label: "Active", value: StudentStatus.Active.toString() },
  { label: "Inactive", value: StudentStatus.Inactive.toString() },
  { label: "Suspended", value: StudentStatus.Suspended.toString() },
  { label: "Expelled", value: StudentStatus.Expelled.toString() },
  { label: "Graduated", value: StudentStatus.Graduated.toString() },
  { label: "To Be Promoted", value: StudentStatus.ToBePromoted.toString() },
  { label: "To Be Graduated", value: StudentStatus.ToBeGraduated.toString() },
];

export const studentStatusMap: {
  [key: number]: { name: string; color: string };
} = {
  0: { name: "Active", color: "green" },
  1: { name: "Inactive", color: "gray" },
  2: { name: "Suspended", color: "gray" },
  3: { name: "Expelled", color: "red" },
  4: { name: "Graduated", color: "gray" },
};

export const colors: { name: string; color: string }[] = [
  { name: "Gray", color: "gray" },
  { name: "Pink", color: "pink" },
  { name: "Default", color: "brand" },
  { name: "Purple", color: "purple" },
  { name: "Cyan", color: "cyan" },
  { name: "Blue", color: "blue" },
  { name: "Teal", color: "teal" },
  { name: "Green", color: "green" },
  { name: "Yellow", color: "yellow" },
  { name: "Orange", color: "orange" },
  { name: "Red", color: "red" },
];

export const auditTrailActions = [
  { label: "All Actions", value: "", color: "" },
  { label: "Create", value: AuditTrailAction.Create, color: "green" },
  { label: "Update", value: AuditTrailAction.Update, color: "blue" },
  { label: "Delete", value: AuditTrailAction.Delete, color: "red" },
  { label: "Result Entry", value: AuditTrailAction.ResultEntry, color: "teal" },
];

export const auditTrailEntityTypes = [
  { label: "All entities", value: "" },
  { label: "Result Entry", value: AuditTrailEntityType.SummaryResultEntry },
  { label: "Guardian", value: AuditTrailEntityType.Guardian },
  { label: "Student", value: AuditTrailEntityType.Student },
  { label: "User", value: AuditTrailEntityType.User },
  { label: "Notification", value: AuditTrailEntityType.Notification },
  { label: "Promotion Rule", value: AuditTrailEntityType.PromotionRule },
  { label: "Student Promotion", value: AuditTrailEntityType.StudentPromotion },
  { label: "Student Data", value: AuditTrailEntityType.StudentData },
];

export const notificationTypeOptions = [
  { label: "All Types", value: "all" },
  { label: "Direct Message", value: NotificationType.DirectMessage.toString() },
  {
    label: "Broadcast Message",
    value: NotificationType.BroadcastMessage.toString(),
  },
  { label: "System Message", value: NotificationType.SystemMessage.toString() },
  {
    label: "Dashboard Update",
    value: NotificationType.DashboardUpdate.toString(),
  },
  { label: "Result Update", value: NotificationType.ResultUpdate.toString() },
];

export const notificationTypeFormOptions = [
  { label: "Direct Message", value: NotificationType.DirectMessage },
  { label: "Broadcast to All", value: NotificationType.BroadcastMessage },
];

export const promotionStatusFilters = [
  {
    label: "All Statuses",
    value: "all",
  },
  {
    label: "Available for Promotion",
    value: PromotionStatus.Available,
  },
  {
    label: "Pending Approval",
    value: PromotionStatus.Pending,
  },
  {
    label: "Approved",
    value: PromotionStatus.Approved,
  },
  {
    label: "Rejected",
    value: PromotionStatus.Rejected,
  },
  {
    label: "Promoted",
    value: PromotionStatus.Promoted,
  },
  {
    label: "Failed",
    value: PromotionStatus.Failed,
  },
];

export const eligibilityFilters = [
  {
    label: "All Students",
    value: "all",
  },
  {
    label: "Eligible Only",
    value: "eligible",
  },
  {
    label: "Ineligible Only",
    value: "ineligible",
  },
];

export const promotionTypeOptions = [
  { label: "All Types", value: "all" },
  { label: "Automatic", value: PromotionType.Automatic },
  { label: "Manual", value: PromotionType.Manual },
  { label: "Session Change", value: PromotionType.SessionChange },
];
